import type { OrderExternalReferenceDto } from "@/api/dtos";
import type { ExternalReference } from "@/api/order/_models/Order";

/** DTO → domain for one system's key for an order; nulls become undefined. */
export const toExternalReferenceFromOrderExternalReferenceDto = (
  dto: OrderExternalReferenceDto,
): ExternalReference => {
  return {
    source: dto.source,
    externalId: dto.externalId ?? undefined,
    externalReference: dto.externalReference ?? undefined,
    createdAt: dto.createdAt,
  };
};
